import { Injectable } from '@angular/core';
import {BaseDatabaseService} from '../BaseDatabaseService';
import {Race} from '../../../classes/Race';



@Injectable({
  providedIn: 'root'
})
export class RacesService extends BaseDatabaseService{

  private collectionName = 'races';


  raceId = undefined;
  race: Race = undefined;

  lastSave: string = undefined;

  constructor() {
    super();
  }

  getRaces() {
    return this.db.collection(this.collectionName).get();
  }

  saveToLocal(id) {
    localStorage.setItem(id, id);
  }

  getLocal(id) {
    return localStorage.getItem(id);
  }

  destrotLocal(id) {
    localStorage.removeItem(id);
  }

  createRace(id, race: Race){
    race.categories = race.categories.map(item => Object.assign({}, item));
    race.startFee = race.startFee.map( item => Object.assign({}, item));
    race.track = race.track.map(item => Object.assign({}, item));
    race.sportType = this.db.collection('sportTypes').doc(race.sportType);
    race.dateStart = new Date(race.dateStart);
    race.dateFinish = new Date(race.dateFinish);
    race.dateOfReg = new Date(race.dateOfReg).getTime();

    race = Object.assign({}, race);
    if (id === undefined) {
      this.lastSave = Date.now().toString();
      return this.db.collection(this.collectionName).doc(this.lastSave).set(race);
    } else {
      return this.db.collection(this.collectionName).doc(id).set(race);
    }
  }

  getOne(id){
    return this.db.collection(this.collectionName).doc(id).get();
  }

  delete(id){
    return this.db.collection(this.collectionName).doc(id).delete();
  }

  update(id, race: Race) {
    race.categories = race.categories.map(item => Object.assign({}, item));
    race.track = race.track.map(item => Object.assign({}, item));
    race.dateStart = new Date(race.dateStart.seconds * 1000);
    race.dateFinish = new Date(race.dateFinish.seconds * 1000);
    race.dateOfReg = new Date(race.dateOfReg).getTime();

    console.dir(id);
    const ref = this.db.collection(this.collectionName).doc(race.id);

    console.dir('lll');

    const sportTypeId = race.sportType.id === undefined ? race.sportType : race.sportType.id;

    race.sportType = this.db.collection('sportTypes').doc(sportTypeId);
    console.log('llo');
    race.startFee.forEach( startFee => {
      startFee.data.forEach( data => {
        data.fee = data.fee.map( item => Object.assign({}, item));
      });
      startFee.data = startFee.data.map(item => Object.assign({}, item));
    });
    console.dir('lll2');
    race.startFee = race.startFee.map( item => Object.assign({}, item));

    if ( race.fioConfig !== undefined && race.fioConfig !== {} ) {
      race.fioConfig = Object.assign({}, race.fioConfig);
    }

    console.dir(ref);

    race = Object.assign({}, race);
    console.dir(race);
    return ref.update(race);
  }

}
